const jobArea = [
    "Recursos Humanos",
    "Compras",
    "Ventas",
    "Finanzas",
    "Contabilidad",
    "Marketing",
    "Tecnologías de la Información (TI)",
    "Logística",
    "Producción",
    "Calidad",
    "Atención al Cliente",
    "Legal",
    "Investigación y Desarrollo (I+D)",
    "Administración",
    "Planeación Estratégica",
    "Mantenimiento",
    "Seguridad y Salud Ocupacional",
    "Relaciones Públicas",
    "Servicios Generales",
    "Desarrollo Organizacional"
  ]
export default jobArea;
